import { useQuery } from "@tanstack/react-query";

import { useAuth } from "./useAuth";

import { QueryKey } from "@/constants/shared";
import { makeRequest } from "@/network/api";
import { SeasonOneStats } from "@/types";

export const useSeasonOneStats = () => {
  const { address } = useAuth();
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKey.SeasonOneStats, address],
    queryFn: async (): Promise<SeasonOneStats> => {
      const response = await makeRequest(
        `stats/season1?walletAddress=${address}`,
      );
      const responseJson = await response.json();
      return responseJson.data.season1Stats;
    },
    enabled: Boolean(address),
    refetchOnMount: false,
  });
  const { miles = 0, flightClass, stamps = 0, referrals = 0 } = data ?? {};

  const bonusPoints = !miles
    ? 0
    : miles >= 5835900
      ? 1000
      : miles >= 1695000
        ? 700
        : miles >= 711500
          ? 500
          : miles >= 136000
            ? 300
            : miles >= 25000
              ? 200
              : miles >= 1000
                ? 100
                : 50;

  return {
    miles,
    flightClass,
    stamps,
    referrals,
    isLoading,
    isError,
    bonusPoints,
  };
};
